import { PaperClipIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";

import { Button, Label, Paragraph } from "@fronterahealth/frontera-ui-components";

interface SessionNoteCardProps {
  author: string;
  text: string;
  previewLength?: number;
}

export const SessionNoteCard: React.FC<SessionNoteCardProps> = ({ author, text, previewLength = 100 }) => {
  const [expanded, setExpanded] = useState(false);

  const shouldTruncate = text.length > previewLength;
  const displayText = expanded ? text : text.slice(0, previewLength);

  return (
    <div className="border rounded-lg bg-limestone-50 p-4 border-limestone-300 ph-no-capture">
      <div className="flex items-center">
        <PaperClipIcon className="h-4 w-4 text-gray-600 mr-1 text-limestone-600" />
        <Label displayType="loud" colorType="primary">
          A note from {author}
        </Label>
      </div>

      <Paragraph displayType="normal" colorType="secondary" className="mt-2">
        {displayText}
        {shouldTruncate && !expanded && "... "}
        {shouldTruncate && (
          <Button
            appearance="link"
            onClick={() => setExpanded(!expanded)}
            className="ml-1 text-gray-500 underline hover:text-gray-700 text-sm text-limestone-600 p-0!"
            text={expanded ? "view less" : "view more"}
          />
        )}
      </Paragraph>
    </div>
  );
};
